import { reactive, ref } from 'vue';

export default {
  name: 'FormSelectRegionCountryComponent',
  props: {
    options: {
      type: Array,
      required: true,
      default: [],
    },
    placeholder: {
      type: String,
      default: 'Please select an option',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
    },
    autocomplete: {
      type: String,
      required: false,
      default: 'on',
    },
    value: {
      type: Object,
      required: false,
      default: null,
    },
    filterLabel: {
      type: Boolean,
      required: false,
      default: false,
    },
    name: {
      type: String,
      required: false,
      default: Math.random().toString(36).substring(2, 7),
    },
  },
  setup(props) {
    const state = reactive({
      options: props.options,
      selected: ref(null),
      optionsShown: ref(false),
      filter: ref(null),
      filtered: ref(props.options),
      filterLabel: props.filterLabel,
    });

    if (props.value) {
      state.selected = props.value;
    }

    return { state };
  },
  methods: {
    select(option) {
      this.state.filter = null;
      this.$emit('selected', option);
      this.state.selected = option;
      this.state.optionsShown = false;
    },
    clear(label) {
      this.state.filter = null;
      this.$emit('selected', { clear: label });
      this.state.selected = null;
      this.state.optionsShown = false;
    },
    toggleOptionsDisplay(event) {
      if (this.disabled) {
        return;
      }
      if (this.state.optionsShown) {
        return event.target.blur();
      }
      this.state.optionsShown = true;
    },
    exit() {
      this.state.filter = null;
      this.state.filtered = this.state.options;
      this.state.optionsShown = false;

      if (this.state.selected && !this.state.selected.id) {
        this.state.selected = {};
        this.$emit('selected', null);
      }
    },
    focus(event) {
      this.state.filtered = this.state.options;
    },
    filter(event) {
      const filter = event.target.value;
      if (27 === event.keyCode) {
        event.target.blur();
        return;
      }
      this.state.filter = filter;
      this.state.selected = { name: filter };
      if (filter) {
        const filtered = this.state.options.filter(option => {
          if (this.state.filterLabel) {
            let result = false;
            if (option.name) {
              result = option.name.toLowerCase().includes(filter.toLowerCase());
            }
            if (!result && option.label) {
              result = option.label.toLowerCase().includes(filter.toLowerCase());
            }
            return result;
          }
          if (option.name) {
            return option.name.toLowerCase().includes(filter.toLowerCase());
          }
          if (option.label) {
            return option.label.toLowerCase().includes(filter.toLowerCase());
          }
        });
        if (filtered.length) {
          this.state.filtered = filtered;
          return;
        }
        this.state.filter = null;
        this.state.filtered = [{ id: -1, name: 'No Results Found' }];
        return;
      }
      this.state.selected = {};
      this.state.filtered = this.state.options;

    }
  },
};
